import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    "row-class-name": "mga-total-list__row",
    "show-header": false,
    border: "",
    size: "small",
    data: [_ctx.totalReport]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        width: "150",
        prop: _ctx.ReportTableHeaders.TOTAL
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.totalText), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["prop"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MGA_REPORT_TABLE_COLUMNS, (header) => {
        return (_openBlock(), _createBlock(_component_el_table_column, {
          key: header.prop,
          width: header.width,
          prop: header.prop
        }, null, 8 /* PROPS */, ["width", "prop"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data"]))
}